import React from "react";
import {css} from "@emotion/react";
import {FormikHelpers} from "formik";
import * as Yup from "yup";

import {borderRadius, mb, onDesktop} from "@pg-design/helpers-css";
import {SystemModal} from "@pg-design/modal-module";
import {FormikForm} from "@pg-mono/formik-utils";

import {hitGtmAddedNewPlace} from "../../../favorite/tracking/favourite_gtm_events";
import {validationMessages} from "../../../form/utils/validation_messages";
import {IPlacesAutocompleteValue, PlacesAutocomplete} from "../../../maps/components/PlacesAutocomplete";
import {isValidLocationObject} from "../../../maps/utils/is_valid_location_object";
import {useComparisonToolContext} from "../../contexts/comparison_tool_context";

export interface IMyPlaceFormValues {
    name: string;
    location: IPlacesAutocompleteValue;
}

/*
    Be aware that this component relies on google maps api provided from the context
 */
export const MyPlaceModal = () => {
    const {changeMyPlaceModalOpened, setChangeMyPlaceModalOpened, setMyPlace} = useComparisonToolContext();

    const initialValues: IMyPlaceFormValues = {
        name: "",
        location: {
            coordinates: []
        }
    };

    const validationSchema = Yup.object({
        name: Yup.string().required(validationMessages.required),
        location: Yup.mixed().test({message: validationMessages.required, test: (values) => isValidLocationObject(values)})
    });

    const closeModal = () => {
        setChangeMyPlaceModalOpened(false);
    };

    const onSubmit = (values: IMyPlaceFormValues, {setSubmitting}: FormikHelpers<IMyPlaceFormValues>) => {
        setMyPlace(values);
        hitGtmAddedNewPlace(values.name);
        setSubmitting(false);
        closeModal();
    };

    return (
        <SystemModal shouldCloseOnOverlayClick onModalClose={closeModal} isOpen={changeMyPlaceModalOpened} css={myPlaceModal}>
            <FormikForm onSubmit={onSubmit} initialValues={initialValues} validationSchema={validationSchema} css={form}>
                {({isSubmitting}) => (
                    <>
                        <SystemModal.Header>Dodaj własne miejsce</SystemModal.Header>
                        <SystemModal.Content css={formContent}>
                            <FormikForm.Input name="name" labelContent="Moja nazwa" placeholder="Moja praca" css={mb(2)} />
                            <PlacesAutocomplete name="location" labelContent="Lokalizacja" placeholder="Cybernetyki 12" css={mb(2)} />
                        </SystemModal.Content>
                        <FormikForm.Button variant="stretched_primary" disabled={isSubmitting} css={submitButton}>
                            Zapisz
                        </FormikForm.Button>
                    </>
                )}
            </FormikForm>
        </SystemModal>
    );
};

/*
    Styles
 */
const myPlaceModal = css`
    overflow: visible;
`;

const form = css`
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
`;

const formContent = css`
    flex: 1 1 auto;
`;

const submitButton = css`
    ${onDesktop(css`
        ${borderRadius(0, 0, 2, 2)}
    `)}
`;
import React from "react";
import {css} from "@emotion/react";
import {FormikHelpers} from "formik";
import * as Yup from "yup";

import {borderRadius, mb, onDesktop} from "@pg-design/helpers-css";
import {SystemModal} from "@pg-design/modal-module";
import {FormikForm} from "@pg-mono/formik-utils";

import {hitGtmAddedNewPlace} from "../../../favorite/tracking/favourite_gtm_events";
import {validationMessages} from "../../../form/utils/validation_messages";
import {IPlacesAutocompleteValue, PlacesAutocomplete} from "../../../maps/components/PlacesAutocomplete";
import {isValidLocationObject} from "../../../maps/utils/is_valid_location_object";
import {useComparisonToolContext} from "../../contexts/comparison_tool_context";

export interface IMyPlaceFormValues {
    name: string;
    location: IPlacesAutocompleteValue;
}

/*
    Be aware that this component relies on google maps api provided from the context
 */
export const MyPlaceModal = () => {
    const {changeMyPlaceModalOpened, setChangeMyPlaceModalOpened, setMyPlace} = useComparisonToolContext();

    const initialValues: IMyPlaceFormValues = {
        name: "",
        location: {
            coordinates: []
        }
    };

    const validationSchema = Yup.object({
        name: Yup.string().required(validationMessages.required),
        location: Yup.mixed().test({message: validationMessages.required, test: (values) => isValidLocationObject(values)})
    });

    const closeModal = () => {
        setChangeMyPlaceModalOpened(false);
    };

    const onSubmit = (values: IMyPlaceFormValues, {setSubmitting}: FormikHelpers<IMyPlaceFormValues>) => {
        setMyPlace(values);
        hitGtmAddedNewPlace(values.name);
        setSubmitting(false);
        closeModal();
    };

    return (
        <SystemModal shouldCloseOnOverlayClick onModalClose={closeModal} isOpen={changeMyPlaceModalOpened} css={myPlaceModal}>
            <FormikForm onSubmit={onSubmit} initialValues={initialValues} validationSchema={validationSchema} css={form}>
                {({isSubmitting}) => (
                    <>
                        <SystemModal.Header>Dodaj własne miejsce</SystemModal.Header>
                        <SystemModal.Content css={formContent}>
                            <FormikForm.Input name="name" labelContent="Moja nazwa" placeholder="Moja praca" css={mb(2)} />
                            <PlacesAutocomplete name="location" labelContent="Lokalizacja" placeholder="Cybernetyki 12" css={mb(2)} />
                        </SystemModal.Content>
                        <FormikForm.Button variant="stretched_primary" disabled={isSubmitting} css={submitButton}>
                            Zapisz
                        </FormikForm.Button>
                    </>
                )}
            </FormikForm>
        </SystemModal>
    );
};

/*
    Styles
 */
const myPlaceModal = css`
    overflow: visible;
`;

const form = css`
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
`;

const formContent = css`
    flex: 1 1 auto;
`;

const submitButton = css`
    ${onDesktop(css`
        ${borderRadius(0, 0, 2, 2)}
    `)}
`;
